import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import { Button, Grid } from "@material-ui/core";
import { FPagosStyle } from "./styles";
import ModalBase from "../../../global/ModalBase";
import HeaderModal from "../../../global/headerModal";
import TResumen from "../TResumen";
import BackDrop from "./../../../global/BackDrop"
import { obtenerResumenes, pagarComision, clearState } from '../../../ducks/cotizacionDuck';
import {ToastMessage } from "./../../../global/ToastMessage"
export default function FPagos(props) {

  const {
    open = false,
    setOpenModal = () => {}
  } = props;

  const classes = FPagosStyle();
  const dispatch = useDispatch()
  const resumenAgente = useSelector(store => store.cotizacion.resumenAgente)
  const resumenMarcado = useSelector(store => store.cotizacion.resumenMarcado)

  const [isLoad, setIsLoad] = useState(false);

  useEffect(()=>{
    if(open)
    {
      setIsLoad(true);
      dispatch(obtenerResumenes()).then((Response) =>{
          setIsLoad(false)
      })
    }
  },[dispatch, open])

  const handlePagarComision = () =>{
    setIsLoad(true);
    dispatch(pagarComision(true)).then((Response) =>{
      if (Response.status && Response.status !== 500) {
        ToastMessage.fire({
          icon: "error",
          title: "Ha habido un problema de conexión con el servidor",
        });
      }
      ToastMessage.fire({
        icon: "success",
        title: "Operación exitosa!",
      });
      setIsLoad(false)
      setOpenModal(false);
    })
  }


  const handleCloseModal = () => {
    dispatch(clearState())
    setOpenModal(false);
  };

  return (
      <ModalBase classes={classes} open={open} onClose={handleCloseModal}>
        <HeaderModal
          handleClose={handleCloseModal}
          titulo={"Resumen de Pago"} 
        />
        <Grid container >
            <Grid item xs={12} >
              <div style={{textAlign: "center"}}>
                <h2>¿Está seguro de pagar las siguientes Comisiones?</h2>
              </div>
            </Grid>
            <Grid item xs={12} >
              <div style={{textAlign: "center"}}>
                {
                  (resumenAgente.comision === resumenMarcado.comision) &&
                    <h3>Los Montos del Resumen son iguales</h3>
                }
                {
                  (resumenAgente.comision !== resumenMarcado.comision) &&
                    <h3>Los Montos del Resumen son diferentes</h3>
                }
              </div>
            </Grid>
            <Grid item xs={12}  >
              <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                <TResumen
                  tituloTabla={'Resumen Agente'}
                  resumen={resumenAgente}
                />
                <TResumen
                  tituloTabla={'Resumen Marcado'}
                  resumen={resumenMarcado}
                />
              </div>
            </Grid> 
            <Grid item xs={12}  >
              <div style={{display:"flex",justifyContent:"center",alignItems:"center", gap: "20px", marginTop: "10px" }}>  
                <Button variant="contained" color="primary" onClick={handlePagarComision}>Estoy de Acuerdo</Button>   
              </div>
            </Grid> 
        </Grid>
        <BackDrop open={isLoad} />
      </ModalBase>
  );
}
